import React from 'react';
import moment from 'moment';

class ListItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = { show_subrow: false };
    }

    getTypeLabel(type) {
        let style = {};

        switch(type) {
            case 'INFO': style = { color: "blue" }; break;
            case 'WARNING':  style = { color: "orange" }; break;
            case 'ERROR':  style = { color: "red" }; break;
            default: break;
        }

        return (<span style={style}>{type}</span>);
    }

    getOperationLabel(operation) {
        switch(operation) {
            case 'INSERT': return 'Criação';
            case 'UPDATE': return 'Atualização';
            case 'DELETE': return 'Remoção';
            default: return operation;
        }
    }

    getContextLabel(context) {

        switch(context.toUpperCase()) {
            case 'USERS': return 'Usuários';
            case 'CUSTOMERS': return 'Clientes';

            case 'VEHICLES': return 'Veículos';
            case 'VEHICLE_CONTRACTS': return 'Contratos de veículo';
            case 'VEHICLE_TYPES': return 'Tipos de veículos';

            case 'DELIVERIES': return 'Entregas';
            case 'DELIVERY_DOCUMENTS': return 'Documentos de Entrega';
            case 'DELIVERY_TYPES': return 'Tipos de rota';

            default: return context;
        }
    }

    getContextsLabel(contexts = []) {
        return contexts.map(this.getContextLabel).join(', ');
    }


    getSubrow(data) {
        if (!this.state.show_subrow) {
            return null;
        }

        return (
            <tr className="subrow">
                <td colSpan={6}>
                    <div>
                        <p><b>Dados técnicos:</b></p>
                        <pre>{JSON.stringify(data.payload, null, 4)}</pre>
                    </div>
                </td>
            </tr>
        );
    }

    toggleSubrow() {
        this.setState({ show_subrow: !this.state.show_subrow });
    }


    render() {
        const data = this.props.data;
        const user = data.user || { display_name: 'Sistema' };
        const subrow = this.getSubrow(data);

        return (
            <tbody>
                <tr onClick={this.toggleSubrow.bind(this)}>
                    <td>{moment(data.date).format('DD/MM/YYYY HH:mm')}</td>
                    <td>{data.message}</td>
                    <td>{this.getTypeLabel(data.type)}</td>
                    <td>{this.getOperationLabel(data.operation)}</td>
                    <td>{this.getContextsLabel(data.tags || [])}</td>
                    <td>{user.display_name}</td>
                </tr>

                {subrow}
            </tbody>
        );
    }

}

ListItem.defaultProps = {
    data: {}
}

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/Logs/ListItem.js